import React, { useState, useEffect } from "react";
import { HiChevronLeft, HiChevronRight } from "react-icons/hi";
import { motion, AnimatePresence } from "framer-motion";

import { AppWrap, MotionWrap } from "../../wrapper";
import { urlFor, client } from "../../client";
import "./Testimonial.scss";
import TensorCerti from "../../assets/tensorflow.jpg";
import { FaArrowUp, FaUpload } from "react-icons/fa";
import { FaArrowUpRightFromSquare } from "react-icons/fa6";

const Testimonial = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [testimonials, setTestimonials] = useState([]);
  const [brands, setBrands] = useState([]);
  const [direction, setDirection] = useState(0);

  const handleClick = (index) => {
    setCurrentIndex(index);
  };

  const nextSlide = () => {
    setDirection(1);
    setCurrentIndex(
      currentIndex === testimonials.length - 1 ? 0 : currentIndex + 1
    );
  };

  const prevSlide = () => {
    setDirection(-1);
    setCurrentIndex(
      currentIndex === 0 ? testimonials.length - 1 : currentIndex - 1
    );
  };

  useEffect(() => {
    const query = '*[_type == "testimonials"]';
    const brandsQuery = '*[_type == "brands"]';

    client.fetch(query).then((data) => {
      // setTestimonials(data);

      let reversedDataCertifications = [...data].reverse();
      setTestimonials(reversedDataCertifications);
    });

    client.fetch(brandsQuery).then((data) => {
      setBrands(data);
    });
  }, []);

  const go2link = (index) => () => {
    window.open(testimonials[index].feedback);
  };

  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        duration: 0.6,
        staggerChildren: 0.2
      }
    }
  };

  const slideVariants = {
    enter: (direction) => ({
      x: direction > 0 ? 1000 : -1000,
      opacity: 0
    }),
    center: {
      zIndex: 1,
      x: 0,
      opacity: 1
    },
    exit: (direction) => ({
      zIndex: 0,
      x: direction < 0 ? 1000 : -1000,
      opacity: 0
    })
  };

  const certificateVariants = {
    hidden: { 
      opacity: 0, 
      scale: 0.8, 
      y: 50 
    },
    visible: { 
      opacity: 1, 
      scale: 1, 
      y: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut"
      }
    },
    hover: {
      scale: 1.02,
      transition: {
        duration: 0.3,
        ease: "easeInOut"
      }
    }
  };

  const buttonVariants = {
    hidden: { opacity: 0, scale: 0.8 },
    visible: { 
      opacity: 1, 
      scale: 1,
      transition: {
        duration: 0.5,
        ease: "easeOut"
      }
    },
    hover: {
      scale: 1.1,
      transition: {
        duration: 0.2,
        ease: "easeInOut"
      }
    },
    tap: {
      scale: 0.95,
      transition: {
        duration: 0.1
      }
    }
  };

  return (
    <motion.div 
      className="fofo"
      variants={containerVariants}
      initial="hidden"
      animate="visible"
    >
      {testimonials.length && (
        <motion.div className="momo">
          <motion.h2 
            className="certificates-title"
            initial={{ opacity: 0, y: -50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
          >
            My <span>Certificates</span> & Achievements
          </motion.h2>

          <motion.div 
            className="app__testimonial-item app__flex"
            variants={certificateVariants}
            initial="hidden"
            animate="visible"
            whileHover="hover"
            key={currentIndex}
          >
            <div className="app_testimonial-main">
              <motion.div
                className="app_testimonial-main-img"
                onClick={go2link(currentIndex)}
                whileHover={{ scale: 1.02 }}
                transition={{ duration: 0.3 }}
              >
                <motion.img
                  src={urlFor(testimonials[currentIndex].imageurl)}
                  alt="certificate"
                  className="certificate-img"
                  initial={{ opacity: 0, scale: 0.9 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.5, delay: 0.2 }}
                />
                <motion.div
                  className="app_testimonial-main-img-overlay"
                  onClick={go2link(currentIndex)}
                  whileHover={{ opacity: 1 }}
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 0 }}
                  transition={{ duration: 0.3 }}
                >
                  <motion.div
                    whileHover={{ scale: 1.2, rotate: 360 }}
                    transition={{ duration: 0.3 }}
                  >
                    <FaArrowUpRightFromSquare className="overlay-icon" />
                  </motion.div>
                </motion.div>
              </motion.div>
              <motion.div 
                className="app-testimonial-name"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.4 }}
              >
                <h3>{testimonials[currentIndex].name}</h3>
                <p className="certificate-org">{testimonials[currentIndex].company}</p>
              </motion.div>
            </div>
          </motion.div>

          <motion.div 
            className="app__testimonial-btns app__flex"
            variants={buttonVariants}
            initial="hidden"
            animate="visible"
          >
            <motion.div
              className="nav-btn prev-btn"
              onClick={prevSlide}
              whileHover="hover"
              whileTap="tap"
              variants={buttonVariants}
            >
              <HiChevronLeft />
            </motion.div>

            <motion.div 
              className="certificate-counter"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.5, delay: 0.6 }}
            >
              {currentIndex + 1} / {testimonials.length}
            </motion.div>

            <motion.div
              className="nav-btn next-btn"
              onClick={nextSlide}
              whileHover="hover"
              whileTap="tap"
              variants={buttonVariants}
            >
              <HiChevronRight />
            </motion.div>
          </motion.div>

          {/* Certificate indicators */}
          <motion.div 
            className="certificate-indicators"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.8 }}
          >
            {testimonials.map((_, index) => (
              <motion.div
                key={index}
                className={`indicator ${index === currentIndex ? 'active' : ''}`}
                onClick={() => handleClick(index)}
                whileHover={{ scale: 1.2 }}
                whileTap={{ scale: 0.9 }}
                transition={{ duration: 0.2 }}
              />
            ))}
          </motion.div>
        </motion.div>
      )}
    </motion.div>
  );
};

export default AppWrap(
  MotionWrap(Testimonial, "app__testimonial"),
  "certificates",
  "app__primarybg"
);
